import React, { useRef } from "react";
import logo from "../../../assets/images/greenshine/green shine logo 1 (1).png";
import emailjs from "@emailjs/browser";
import { FaFacebook, FaTwitter, FaInstagramSquare } from "react-icons/fa";
const serviceId = "service_wgn6a48";
const templateId = "template_qgncrei";
const publicKey = "AURI02RQxU2MlEqJ5";
// update 
const Footer = () => {
  const form = useRef();
  const sendForm = (e) => {
    e.preventDefault();
    console.log(form.current);
    emailjs
      .sendForm(
        serviceId,
        templateId,
        form.current,
        publicKey
      )
      .then(
        (result) => {
          console.log("email sent ", result.status, result.text);
        },
        (error) => {
          console.log("error", error.text);
        }
      );
    // Reset the form fields
    e.target.reset();
  };
  return (
    <div className=" my-20 md:px-16 px-8">
      <div className="grid md:grid-cols-2 gap-5  ">
        <div className=" flex flex-col gap-5 order-1 md:order-none">
          <div>
            <img src={logo} className="w-40" alt="" />
          </div>
          <div className="lg:w-[400px]">
            <address>
              Green Shine Company Limited Yangon Office: No (502), 4TH Floor, Golden Link Condo, Link Street, Bahan Township (11201), Yangon, Myanmar
            </address>
            <address className="mt-10">
              Green Shine Company Limited Pathein Factory (Rice Mill): C – 53,
              Pathein Industrial Project, Pathein – Nga Pu Taw road, Pathein
              Township, Ayarwaddy Region, Myanmar (10011).
            </address>
            <p className="text-start   mt-10">
              Copyright © {new Date().getFullYear()}- All rights reserved by{" "}
              <span className="font-bold">GreenShine</span>
            </p>
            <div className="flex items-center gap-3 mt-3">
              <button className="hover:scale-105 transition">
                <FaFacebook className="text-blue-500 text-2xl" />
              </button>
              <button className="hover:scale-105 transition">
                <FaTwitter className="text-cyan-500 text-2xl" />
              </button>
              <button className="hover:scale-105 transition">
                <FaInstagramSquare className="text-red-500 text-2xl" />
              </button>
            </div>
          </div>
        </div>
        <div>
          <form action="#" onSubmit={sendForm} ref={form} class="space-y-8">
            <div>
              <label
                for="email"
                class="block titlefont mb-2 text-sm font-medium text-gray-900 ">
                Your email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400  dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="example@gmail.com"
                required
              />
            </div>
            <div>
              <label
                for="subject"
                class="block mb-2 text-sm font-medium text-gray-900 ">
                Subject
              </label>
              <input
                type="text"
                name="subject"
                id="subject"
                class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500  dark:border-gray-600 dark:placeholder-gray-400  dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="Let us know how we can help you"
                required
              />
            </div>
            <div class="sm:col-span-2">
              <label
                for="message"
                class="block mb-2 text-sm font-medium text-gray-900 ">
                Your message
              </label>
              <textarea
                id="message"
                rows="6"
                name="message"
                class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500  dark:border-gray-600 dark:placeholder-gray-400  dark:focus:ring-primary-500 dark:focus:border-primary-500"
                placeholder="Leave a comment..."></textarea>
            </div>
            <button
              type="submit"
              value="Send"
              class="py-3 px-5 text-sm font-medium text-center rounded-lg border border-green-500 hover:bg-green-500 transition-all  hover:text-white sm:w-fit hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 ">
              Send message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Footer;
